import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_125: DocMigration = {
  maxSchemaVersion: "0.0.125",
  description: "Introducting roof versioning.",
  apply(json: any) {
    const { roofs } = json;

    for (const roofId in roofs) {
      const roof = roofs[roofId];

      let roofVersion = 0;
      if (roof.useNewSideOverhangMethod) {
        roofVersion = 1;
        delete roof.useNewSideOverhangMethod;
      }

      roof.roofVersion = roofVersion;
    }

    return json;
  },
};

export default migration_0_0_125;
